<script src="plugins/stores/loader.js"></script>
<template>
  <v-app>

    <v-progress-linear
        indeterminate
        v-if="loading"
        class="axiosLoader"
    ></v-progress-linear>

    <div v-if="isAdmin" :class="'environment-message environment-'+environment">{{ environment.toUpperCase() }}</div>

    <nav-bar v-if="isAuthenticated"></nav-bar>
    <nav-bar-not-logged-in v-if="!isAuthenticated"></nav-bar-not-logged-in>

    <v-main :style="{background: $vuetify.theme.themes[theme].background}">
      <v-alert
          class="ma-4 mx-4 mx-md-8"
          v-if="appOnline === false"
          dense
          prominent
          type="warning"
      >
        U bent momenteel offline. U kunt formulieren niet versturen maar wel lokaal opslaan. Ga niet uitloggen als u nog lokaal opgeslagen registraties heeft die alleen op dit apparaat staan.
      </v-alert>

      <v-alert
          class="ma-4 mx-4 mx-md-8"
          v-if="serverNotification && serverNotification.message"
          :type="serverNotification.type"
      >
        {{ serverNotification.message }}
      </v-alert>

      <page-title v-if="!($route.meta && $route.meta.hidePageTitle)"></page-title>

      <div class="container-wrapper">
        <router-view :key="$route.fullPath"></router-view>
      </div>

    </v-main>

    <v-snackbar bottom center :value="updateExists" :timeout="-1" color="primary">
      <p>
        <span class="font-weight-bold">Nieuwe update beschikbaar.</span><br>
        Sla uw werk op voordat u update.
      </p>
      <v-btn outlined @click="refreshApp">
        Nu updaten
      </v-btn>
    </v-snackbar>

    <terms-and-conditions-wall
        v-for="(item, i) in termsAndConditionsRequired"
        :key="i"
        :client_uuid="item"
    >
    </terms-and-conditions-wall>

  </v-app>
</template>

<script>
import NavBar from "./components/NavBar";
import NavBarNotLoggedIn from "@/components/NavBarNotLoggedIn.vue";
import store from './plugins/store';
import update from '@/plugins/update'
import PageTitle from '@/components/Pagetitle'
import userHelpers from "@/mixins/userHelpers";
import {mapGetters,mapState} from "vuex";
import TermsAndConditionsWall from "@/components/TermsAndConditionsWall";
import loggingHelpers from "@/mixins/loggingHelpers";

export default {
  name: 'App',
  components: {
    TermsAndConditionsWall,
    NavBar,
    NavBarNotLoggedIn,
    PageTitle,
  },
  mixins: [update, userHelpers, loggingHelpers],
  created: function() {
    this.pollUserInfo()
    this.pollRegistrationOutbox()
  },
  methods: {
    pollUserInfo () {
      this.userInfoPolling = setInterval(() => {
        // Fetch user and client info
        if (store.getters.isAuthenticated) {
          this.$store.dispatch('UserInfo');
        }
      }, 60000) // Every 1 minute
    },
    pollRegistrationOutbox () {
      setInterval(() => {
        if (store.getters.isAuthenticated) {
          this.$store.dispatch('registrationOutbox/syncPendingRegistrationsToServer');
        }
      }, 180000) // Every 3 minutes
    },
  },
  data () {
    return {
      environment: process.env.VUE_APP_ENVIRONMENT,
      userInfoPolling: null,
    }
  },
  computed: {
    ...mapGetters({User: "StateUser"}),
    ...mapState('loader', ['loading']),
    appOnline() {
      return store.getters.appOnline;
    },
    isAuthenticated() {
      return store.getters.isAuthenticated;
    },
    isAdmin() {
      return store.getters.userIsAdmin;
    },
    termsAndConditionsRequired() {
      return store.getters.termsAndConditionsRequired;
    },
    serverNotification() {
      return store.getters.serverNotification ? store.getters.serverNotification : false;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    }
  },
  async mounted() {
    // We need to wait till storage is restored because committing new changes.
    await store.restored

    // Force logout users when they still have old oauth access key.
    // if (store.getters.isAuthenticated && _.has(this.$store.state.auth, 'access_token')) {
    //   this.$router.push({ name: 'logout'})
    // }

    // Add user data to rollbar so we can identify the user when an error occurs.
    this.configureLoggingUser();

    // Reset loader
    store.commit('loader/reset');
    // Set online status
    store.commit('setOnlineStatus', navigator.onLine);

    const onlineHandler = () => {
      console.log('User is online');
      this.$emit('online')
      store.commit('setOnlineStatus', true);
    }

    const offlineHandler = () => {
      console.log('User is offline')
      this.$emit('offline')
      store.commit('setOnlineStatus', false);
    }

    window.addEventListener('online',  onlineHandler)
    window.addEventListener('offline',  offlineHandler)



    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('online', onlineHandler)
      window.removeEventListener('offline', offlineHandler)
    })
  },
  beforeDestroy () {
    clearInterval(this.userInfoPolling)
  },
};
</script>

<style lang="scss">

// Import Formulate styles
@import '../node_modules/@braid/vue-formulate/themes/snow/snow.scss';
// Override default theme with our own styles
@import 'styles/formulate.scss';

html, body {
  overscroll-behavior: none;
}

.environment-message {
  color: white;
  font-size: 11px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  height: 15px;
  text-align: center;
  width: 100%;

  &.environment-development {
    display: none;
  }
  &.environment-staging {
    background: var(--v-warning-lighten2);
  }
  &.environment-production {
    background: var(--v-error-base);
  }
}

.axiosLoader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  width: 100%;
}

// Add subtle shadow to the footer
footer.eform-footer-transparant {
  border-top: 1px solid map-get($material-theme, 'dividers') !important;
  z-index: 10; // To make sure it's above the Vue formulate file upload masks

  &.theme--light {
    background-color: rgba(255, 255, 255, 0.95) !important;

    @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
      -webkit-backdrop-filter: saturate(180%) blur(20px);
      backdrop-filter: saturate(180%) blur(20px);
      background-color: rgba(242, 242, 246, 0.6) !important; // Same as var(--v-background-base) with some transparency
    }
  }
  &.theme--dark {
    background-color: rgba(0, 0, 0, 0.95) !important;

    @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
      -webkit-backdrop-filter: saturate(180%) blur(20px);
      backdrop-filter: saturate(180%) blur(20px);
      background-color: rgba(38, 50, 56, 0.75) !important; // Same as var(--v-background-base) with some transparency
    }
  }
}

.v-tab {
 text-transform: none;
}

.Vue-Toastification__container {
  .Vue-Toastification__toast--success {
    background-color: var(--v-secondary-base);
  }
  .Vue-Toastification__toast--error {
    background-color: var(--v-error-base);
  }
  .Vue-Toastification__toast--warning {
    background-color: var(--v-warning-base);
  }
}

.background-color {
  background-color: var(--v-background-base) !important;
}

.v-card__text, .v-card__title {
  word-break: break-word; // Break on word instead of letter on all v-card elements
}

.v-overlay {
  &.v-overlay--active .v-overlay__scrim {
    opacity: 0.7 !important;
  }
}

.theme--dark {
  .v-dialog {
    border: 1px solid var(--v-border-base);
    //box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.52);
  }
}
// Theme dark Highlight data table rows on hover
.theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: var(--v-background-lighten1) !important;
}

.theme--dark {
  .v-expansion-panel {
    border: 1px solid var(--v-border-base);
    margin-bottom: -1px;
  }
}


</style>
